<template>
    <tr class="cart-locations-row">				
        <td colspan="2" class="cart-locations">{{ currentLocationDetails.locationcity}}</td>
        <td colspan="3" class="cart-locations cart-locations-order-number">Order: {{currentOrderNumber.ord_number}}</td>
    </tr>
    <tr class="order-list__header">
        <th class="order-list__column-label" colspan="2">Product</th>
        <th class="order-list__column-quantity">Quantity</th>
        <th class="order-list__column-total">Total</th>
    </tr>
    <template v-for="ordered_product in standardItems" :key="ordered_product.linenumber">
        <tr>
            <td class="order-list__column-image">
                <div class="image image--type--product">
                    <router-link to="#" class="image__body">
                        <img class="image__tag" :src="ordered_product.image" :alt="ordered_product.product_name">
                    </router-link>
                </div>
            </td>
            <td class="order-list__column-product">
                <strong>
                    <router-link to="ordered_product.url">
                        {{ordered_product.product_name}} {{ordered_product.product_dessc}} <span v-if="ordered_product.XRITMC != ''">({{ordered_product.XRITMC}})</span>
                    </router-link>
                </strong>
            </td>
            <td class="order-list__column-quantity" data-title="Quantity:">{{ordered_product.quantity}}</td>
            <td class="order-list__column-total notranslate" v-if="ordered_product.kit_components == undefined"> {{toUSD(ordered_product.quantity * ordered_product.price)}}</td>
            <td class="order-list__column-total notranslate" v-else> {{toUSD(ordered_product.price)}}</td>
        </tr>
        
        <tr v-if="ordered_product.kit_components.length > 0">
            <td></td>
            <td colspan="3">
                <table class="checkout__totals">
                    <thead class="checkout__totals-header">
                        <tr>
                            <th>Item</th>
                            <th class="checkout-summary-qty--head"></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="checkout__totals-products">
                        <tr v-for="(kc, index) in ordered_product.kit_components" :key="index">
                            <td>
                                {{kc.desc}}<br />
                                <small>Item: {{kc.item}}</small>
                                <small style="margin-left: 10px" v-if="kc.origItem">ALTERNATE for Item: {{kc.origItem}}</small>
                                <small style="margin-left: 10px">MFR: {{kc.manufacturer}}</small>
                            </td>
                            <td class="checkout-summary-qty"><div class="checkout-summary-qty">{{kc.quantity}}</div></td>
                            <td>{{toUSD(kc.linetotal)}}</td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>

    </template>

</template>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';

export default {
    props: {
        currentlocationid: {
            type: String,
            required: true
        },
        order_number: {
            type: String
        },
        name: {
            type: String
        },
        // ordered_items: {
        //     type: Array
        // },
    },
    mixins: [
        Price
    ],
    computed: {
        ...mapGetters([
            'getDefaultLocationDetails'
        ]),
        ...mapGetters('cart', [
            'ordered_items'
        ]),
        standardItems() {
            const st = this.ordered_items.filter(item => {
                // console.log('item.EKKITF = ' + item.EKKITF);
                if (this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                    return (item.locationid === undefined || item.locationid === this.currentlocationid) && !item.backorder;
                } else {
                    return (item.locationid === this.currentlocationid) && !item.backorder;
                }
            });

            console.log(st);

            return st;
        },

        kit_components() {
            return this.ordered_items.filter(item => (item.EKKITF == 'C'));
        },

        currentLocationDetails() {
            let current = this.ordered_items.find((item) => item.locationid === this.currentlocationid);

            if (current === undefined && this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                // Try to get the default location instead
                current = {
                    "locationid": this.getDefaultLocationDetails.defaultlocationid,
                    "locationname": this.getDefaultLocationDetails.defaultlocationname,
                    "locationcity": this.getDefaultLocationDetails.defaultlocationcity,
                    "locationstate": this.getDefaultLocationDetails.defaultlocationstate
                }
            }

            return current;
        },

        currentOrderNumber() {
            let current = this.ordered_items.find((item) => item.locationid === this.currentlocationid);
            return current;
        }
    },
}
</script>

<style scoped>
    .cart-locations.cart-locations-order-number{
        text-align: right;
    }
</style>